import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ReactSelectInput } from '..';
const ReactSelectAsyncCreatableInputComponent = (_a, ref) => {
    var { cacheOptions = true, defaultOptions = true, variant = 'normal' } = _a, props = __rest(_a, ["cacheOptions", "defaultOptions", "variant"]);
    return (_jsx(ReactSelectInput, Object.assign({ cacheOptions: cacheOptions, defaultOptions: defaultOptions, isAsync: true, isCreatable: true, variant: variant }, props, { ref: ref })));
};
export const ReactSelectAsyncCreatableInput = forwardRef(ReactSelectAsyncCreatableInputComponent);
const ReactSelectAsyncInputComponent = (_a, ref) => {
    var { cacheOptions = true, defaultOptions = true, variant = 'normal' } = _a, props = __rest(_a, ["cacheOptions", "defaultOptions", "variant"]);
    return (_jsx(ReactSelectInput, Object.assign({ cacheOptions: cacheOptions, defaultOptions: defaultOptions, isAsync: true, variant: variant }, props, { ref: ref })));
};
export const ReactSelectAsyncInput = forwardRef(ReactSelectAsyncInputComponent);
//# sourceMappingURL=index.js.map